import { Fragment } from 'react';
import { Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import useUnmount from 'common/hooks/useUnmount';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';

import { LoginForm, PasswordEditForm } from 'common/forms';
import { LoginFormValues, PasswordEditFormValues } from 'common/models/User';
import { I18nNameSpaces } from 'common/services/i18n';

import { AuthPageDescription } from '../../components';
import { loginActions, selectLoginError, loginResetAction } from './ducks';
import { selectIsLogged, selectUserProfile } from '../../ducks';
import api from '../../../../common/api';

function LoginFeature() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation(I18nNameSpaces.Auth);
  const isLogged = useSelector(selectIsLogged);
  const error = useSelector(selectLoginError);
  const profile = useSelector(selectUserProfile);

  useUnmount(() => {
    dispatch(loginResetAction());
  });

  function handleLoginSubmit(values: LoginFormValues) {
    dispatch(loginActions.request(values));
  }

  function handleForgottenPasswordClick() {
    navigate('/auth/forgotten-password');
  }

  function handlePasswordEdit(values: PasswordEditFormValues) {
    api.user.updatePassword(values.password).then(() => {
      if (profile && values.password) {
        dispatch(
          loginActions.request({
            email: profile.email,
            password: values.password,
          }),
        );
      }
    });
  }

  return (
    <>
      {profile?.stats?.login === 1 ? (
        <Row justify="center">
          <Col xs={24} md={8}>
            <AuthPageDescription
              title={t('registration.page.title', {
                name: profile?.firstName ?? '',
              })}
            />
            <PasswordEditForm onSubmit={handlePasswordEdit} />
          </Col>
        </Row>
      ) : (
        <>
          {isLogged ? <Navigate to="/" replace /> : null}
          <Row justify="center">
            <Col xs={24} md={8}>
              <AuthPageDescription title={t('login.page.title')} />
              <LoginForm onSubmit={handleLoginSubmit} onForgotPassword={handleForgottenPasswordClick} error={error} />
            </Col>
          </Row>
        </>
      )}
    </>
  );
}

export default LoginFeature;
